export interface SecurityTokenDto
{
    //getSecurityCounter(): string;
}

export class SecurityTokenDtoImpl implements SecurityTokenDto
{
    /* private securityCounter: string;

    getSecurityCounter(): string 
    {
        return this.securityCounter;
    }
    setSecurityCounter(securityCounter: string)
    {
        this.securityCounter = securityCounter;
    } */
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/securitytoken/securitytokendto.tsx